import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import { setRouterNavigate } from '~publish/helpers/routerNavigate'

/**
 * Exposes the router's `navigate` to code outside the React tree via
 * `routerNavigate()`. Render once, inside the `BrowserRouter`.
 */
export function RouterNavigateBridge(): null {
  const navigate = useNavigate()

  useEffect(() => {
    setRouterNavigate(navigate)
    return (): void => {
      setRouterNavigate(null)
    }
  }, [navigate])

  return null
}
